"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_native_1 = require("react-native");
const react_1 = __importDefault(require("react"));
const styles_1 = require("../styles");
const CardCaption = ({ height = 'normal', children, color = 'default', style }) => {
    return (react_1.default.createElement(react_native_1.View, { style: react_native_1.StyleSheet.flatten([
            colorStyles[color],
            captionHeight[height],
            { paddingHorizontal: styles_1.getSpacing(1.2), justifyContent: 'center' },
            style,
        ]) }, children));
};
exports.default = CardCaption;
const captionHeight = react_native_1.StyleSheet.create({
    small: {
        height: 27,
    },
    normal: {
        height: 32,
    },
});
const colorStyles = react_native_1.StyleSheet.create({
    primary: {
        backgroundColor: styles_1.Colors.primary,
    },
    secondary: {
        backgroundColor: styles_1.Colors.secondary,
    },
    default: {
        backgroundColor: styles_1.Colors.lightBlue,
    },
    white: {
        backgroundColor: styles_1.Colors.white,
    },
    lightGray: {
        backgroundColor: styles_1.Colors.lightgrey,
    },
});
